module.exports = __webpack_public_path__ + "static/media/LogoABA.45d1bdc0.png";